// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--b721f";
export var arrow = "accordion-module--arrow--26f75";
export var button = "accordion-module--button--2411c";
export var buttonarrow = "accordion-module--buttonarrow--a0656";
export var content = "accordion-module--content--2bed1";
export var inner = "accordion-module--inner--ff322";
export var item = "accordion-module--item--0b9c0";
export var light = "accordion-module--light--612b4";
export var open = "accordion-module--open--657d7";